import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { connect } from 'react-redux';
import { searchClients, addTableClient, deleteTableClient, clearTableClients } from '../../../flux/actions/clientActions';
import { IVClientContainer, IClientContainerReduxProps, IClient, ITableClientLine, ITarget } from '../../../types/interfaces';
import VClientTable from './VClientTable';
import ClientAdd from '../../client/ClientAdd';
// import ClientVenteAdd from './ClientVenteAdd';

import AsyncSelect from 'react-select/async';
import { useAlert } from "react-alert";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPlus, faSearch} from '@fortawesome/free-solid-svg-icons'
import { PRIVILEGE } from '../../../types/privileges';

const VClientContainer = ({
  addTableClient,
  deleteTableClient,
  clearTableClients,
  client,
  // tableLines,
  // setTableLines,
  userValue,
  projet,
  auth
}: IVClientContainer) => {
  const alert = useAlert();
  const { table_clients } = client;
  const [selectedValue, setSelectedValue] = useState('');
  const [lineCountValue, setLineCount] = useState(0);
  const [modal, setModal] = useState(false);
  const [asyncSelectKey, setAsyncSelectKey] = useState(0);
  
  const handleToggle = () => setModal(!modal);

  useEffect(() => clearTableClients(), []);

  // const loadOptions = async (text, callback) => {
  //     const data: ITableClientLine[] = await searchClients(text);
  //     console.log("data", data)
  //     callback(data.map((dataElement) => ({value: dataElement, label: `${dataElement.PRENOM} ${dataElement.NOM}`})))
  // }
  
  const promiseOptions = inputValue =>
    new Promise(resolve => {
      searchClients(inputValue).then(e => 
        resolve(e.map(t => ({label: `${t.NOM} ${t.PRENOM}`, value: t})))
      ).catch(err => resolve([]));
    });

  const handleSelectChange = data => {
    if(data?.value){
      if(data.value.blocked)
        alert.error(`Le client "${data.value.NOM || ""} ${data.value.PRENOM || ""}" est bloqué, veuillez contacter la direction pour plus d'informations`)
      else
        addTableClient(data.value)
    }
    // if(data?.value && !tableLines.map(e => e.id).includes(data.value.id)){
    //   setTableLines([...tableLines, {...data.value, lineIndex: lineCountValue}]);
    //   setLineCount(lineCountValue + 1);
    // }
    setSelectedValue('');
  }

  const deleteTableClientC = (id: number) => {
    // const tableLinesTemp = tableLines.filter(e => e.lineIndex !== lineIndex);
    // setTableLines(tableLinesTemp);
    deleteTableClient(id)
  };

  const addTableClientCallback = (client: IClient) => {
    addTableClient(client)
    setAsyncSelectKey(e => e + 1)
  };

  return (
    <div>
      <Container className="addClientLineDiv">
        <Row className="justify-content-start mb-3">
          <Col xs="12" md="5">
            <FormGroup style={{marginBottom: '0.3rem'}}>
              <Label for="client">Sélectionner le(s) client(s)</Label>
              <AsyncSelect
                  id="client"
                  className="reactselect"
                  classNamePrefix="react-select"
                  key={asyncSelectKey}
                  cacheOptions
                  defaultOptions
                  value={selectedValue ? {label: selectedValue["NOM"], value: selectedValue} : null}
                  // loadOptions={(e, t) => loadOptions(e, t)}
                  loadOptions={promiseOptions}
                  onChange={handleSelectChange}
                  placeholder={'Chercher par nom ou par CIN...'}
                  isClearable={true}
                  loadingMessage={() => 'Chargement...'}
                  noOptionsMessage={() => 'pas de resultat'}
              />
            </FormGroup>
          </Col>
          {auth?.user?.privileges?.includes(PRIVILEGE.ADD_CLIENT) && <Col xs="12" md="1" className="text-center orLabelCol">
            <Label className="addClientLineLabel">&nbsp;</Label>
            <Label className="orLabel">Ou</Label>
          </Col>}
          {auth?.user?.privileges?.includes(PRIVILEGE.ADD_CLIENT) && <Col xs="12" md="5">
            <Label className="addClientLineLabel">&nbsp;</Label>
            <Button
              className="btn btn-success addClientVenteBtn"
              onClick={() => setModal(true)}
              ><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajouter un nouveau client</Button>
          </Col>}
        </Row>
      </Container>
      <VClientTable linesData={/*tableLines*/table_clients} deleteTableClientC={deleteTableClientC} />
      <ClientAdd modal={modal} setModal={setModal} handleToggle={handleToggle} addTableClientCallback={addTableClientCallback} autoSelectUserId={userValue?.id} projet={projet} />
    </div>
  );
};

const mapStateToProps = (state: IClientContainerReduxProps) => ({
  client: state.client,
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { addTableClient, deleteTableClient, clearTableClients })(VClientContainer);
